import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  ColorType, IconType, ShapeType, SizeType,
} from '@/types/ui-components';
import {
  computed, withDefaults,
} from 'vue';

interface Props {
  icon: IconType;
  size?: SizeType;
  color?: ColorType;
  shape?: ShapeType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwIcon',
  props: {
    icon: { default: 'sw-icon-like' },
    size: { default: 'medium' },
    color: { default: 'primary' },
    shape: { default: '' }
  },
  setup(__props: any) {

const props = __props as { icon: IconType, size: SizeType, color: ColorType, shape: ShapeType }



/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-icon': true,
  [`sw-icon--${props.size || 'medium'}`]: true,
  [`sw-icon--${props.color || 'primary'}`]: true,
  [`sw-icon--${props.shape || 'solid'}`]: !!props.shape,
  'sw-icon--none': !props.shape,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(__props.icon)
    }, null, 2)
  ], 2))
}
}

})